export const countries = [
	{ name: 'Afghanistan', smsPrefix: 93, code: 'AF' },
	{ name: 'Albania', smsPrefix: 355, code: 'AL' },
	{ name: 'Algeria', smsPrefix: 213, code: 'DZ' },
	{ name: 'American Samoa', smsPrefix: 1684, code: 'AS' },
	{ name: 'Andorra', smsPrefix: 376, code: 'AD' },
	{ name: 'Angola', smsPrefix: 244, code: 'AO' },
	{ name: 'Anguilla', smsPrefix: 1264, code: 'AI' },
	{ name: 'Antarctica', smsPrefix: 672, code: 'AQ' },
	{ name: 'Antigua and Barbuda', smsPrefix: 1268, code: 'AG' },
	{ name: 'Argentina', smsPrefix: 54, code: 'AR' },
	{ name: 'Armenia', smsPrefix: 374, code: 'AM' },
	{ name: 'Aruba', smsPrefix: 297, code: 'AW' },
	{ name: 'Australia', smsPrefix: 61, code: 'AU' },
	{ name: 'Austria', smsPrefix: 43, code: 'AT' },
	{ name: 'Azerbaijan', smsPrefix: 994, code: 'AZ' },
	{ name: 'Bahamas', smsPrefix: 1242, code: 'BS' },
	{ name: 'Bahrain', smsPrefix: 973, code: 'BH' },
	{ name: 'Bangladesh', smsPrefix: 880, code: 'BD' },
	{ name: 'Barbados', smsPrefix: 1246, code: 'BB' },
	{ name: 'Belarus', smsPrefix: 375, code: 'BY' },
	{ name: 'Belgium', smsPrefix: 32, code: 'BE' },
	{ name: 'Belize', smsPrefix: 501, code: 'BZ' },
	{ name: 'Benin', smsPrefix: 229, code: 'BJ' },
	{ name: 'Bermuda', smsPrefix: 1441, code: 'BM' },
	{ name: 'Bhutan', smsPrefix: 975, code: 'BT' },
	{ name: 'Bolivia', smsPrefix: 591, code: 'BO' },
	{ name: 'Bosnia and Herzegovina', smsPrefix: 387, code: 'BA' },
	{ name: 'Botswana', smsPrefix: 267, code: 'BW' },
	{ name: 'Brazil', smsPrefix: 55, code: 'BR' },
	{ name: 'British Indian Ocean Territory', smsPrefix: 246, code: 'IO' },
	{ name: 'British Virgin Islands', smsPrefix: 1284, code: 'VG' },
	{ name: 'Brunei', smsPrefix: 673, code: 'BN' },
	{ name: 'Bulgaria', smsPrefix: 359, code: 'BG' },
	{ name: 'Burkina Faso', smsPrefix: 226, code: 'BF' },
	{ name: 'Burundi', smsPrefix: 257, code: 'BI' },
	{ name: 'Cambodia', smsPrefix: 855, code: 'KH' },
	{ name: 'Cameroon', smsPrefix: 237, code: 'CM' },
	{ name: 'Canada', smsPrefix: 1, code: 'CA' },
	{ name: 'Cape Verde', smsPrefix: 238, code: 'CV' },
	{ name: 'Cayman Islands', smsPrefix: 1345, code: 'KY' },
	{ name: 'Central African Republic', smsPrefix: 236, code: 'CF' },
	{ name: 'Chad', smsPrefix: 235, code: 'TD' },
	{ name: 'Chile', smsPrefix: 56, code: 'CL' },
	{ name: 'China', smsPrefix: 86, code: 'CN' },
	{ name: 'Christmas Island', smsPrefix: 61, code: 'CX' },
	{ name: 'Cocos Islands', smsPrefix: 61, code: 'CC' },
	{ name: 'Colombia', smsPrefix: 57, code: 'CO' },
	{ name: 'Comoros', smsPrefix: 269, code: 'KM' },
	{ name: 'Cook Islands', smsPrefix: 682, code: 'CK' },
	{ name: 'Costa Rica', smsPrefix: 506, code: 'CR' },
	{ name: 'Croatia', smsPrefix: 385, code: 'HR' },
	{ name: 'Cuba', smsPrefix: 53, code: 'CU' },
	{ name: 'Curacao', smsPrefix: 599, code: 'CW' },
	{ name: 'Cyprus', smsPrefix: 357, code: 'CY' },
	{ name: 'Czech Republic', smsPrefix: 420, code: 'CZ' },
	{ name: 'Democratic Republic of the Congo', smsPrefix: 243, code: 'CD' },
	{ name: 'Denmark', smsPrefix: 45, code: 'DK' },
	{ name: 'Djibouti', smsPrefix: 253, code: 'DJ' },
	{ name: 'Dominica', smsPrefix: 1767, code: 'DM' },
	{ name: 'Dominican Republic', smsPrefix: 1809, code: 'DO' },
	{ name: 'East Timor', smsPrefix: 670, code: 'TL' },
	{ name: 'Ecuador', smsPrefix: 593, code: 'EC' },
	{ name: 'Egypt', smsPrefix: 20, code: 'EG' },
	{ name: 'El Salvador', smsPrefix: 503, code: 'SV' },
	{ name: 'Equatorial Guinea', smsPrefix: 240, code: 'GQ' },
	{ name: 'Eritrea', smsPrefix: 291, code: 'ER' },
	{ name: 'Estonia', smsPrefix: 372, code: 'EE' },
	{ name: 'Ethiopia', smsPrefix: 251, code: 'ET' },
	{ name: 'Falkland Islands', smsPrefix: 500, code: 'FK' },
	{ name: 'Faroe Islands', smsPrefix: 298, code: 'FO' },
	{ name: 'Fiji', smsPrefix: 679, code: 'FJ' },
	{ name: 'Finland', smsPrefix: 358, code: 'FI' },
	{ name: 'France', smsPrefix: 33, code: 'FR' },
	{ name: 'French Polynesia', smsPrefix: 689, code: 'PF' },
	{ name: 'Gabon', smsPrefix: 241, code: 'GA' },
	{ name: 'Gambia', smsPrefix: 220, code: 'GM' },
	{ name: 'Georgia', smsPrefix: 995, code: 'GE' },
	{ name: 'Germany', smsPrefix: 49, code: 'DE' },
	{ name: 'Ghana', smsPrefix: 233, code: 'GH' },
	{ name: 'Gibraltar', smsPrefix: 350, code: 'GI' },
	{ name: 'Greece', smsPrefix: 30, code: 'GR' },
	{ name: 'Greenland', smsPrefix: 299, code: 'GL' },
	{ name: 'Grenada', smsPrefix: 1473, code: 'GD' },
	{ name: 'Guam', smsPrefix: 1671, code: 'GU' },
	{ name: 'Guatemala', smsPrefix: 502, code: 'GT' },
	{ name: 'Guernsey', smsPrefix: 441481, code: 'GG' },
	{ name: 'Guinea', smsPrefix: 224, code: 'GN' },
	{ name: 'Guinea-Bissau', smsPrefix: 245, code: 'GW' },
	{ name: 'Guyana', smsPrefix: 592, code: 'GY' },
	{ name: 'Haiti', smsPrefix: 509, code: 'HT' },
	{ name: 'Honduras', smsPrefix: 504, code: 'HN' },
	{ name: 'Hong Kong', smsPrefix: 852, code: 'HK' },
	{ name: 'Hungary', smsPrefix: 36, code: 'HU' },
	{ name: 'Iceland', smsPrefix: 354, code: 'IS' },
	{ name: 'India', smsPrefix: 91, code: 'IN' },
	{ name: 'Indonesia', smsPrefix: 62, code: 'ID' },
	{ name: 'Iran', smsPrefix: 98, code: 'IR' },
	{ name: 'Iraq', smsPrefix: 964, code: 'IQ' },
	{ name: 'Ireland', smsPrefix: 353, code: 'IE' },
	{ name: 'Isle of Man', smsPrefix: 441624, code: 'IM' },
	{ name: 'Israel', smsPrefix: 972, code: 'IL' },
	{ name: 'Italy', smsPrefix: 39, code: 'IT' },
	{ name: 'Ivory Coast', smsPrefix: 225, code: 'CI' },
	{ name: 'Jamaica', smsPrefix: 1876, code: 'JM' },
	{ name: 'Japan', smsPrefix: 81, code: 'JP' },
	{ name: 'Jersey', smsPrefix: 441534, code: 'JE' },
	{ name: 'Jordan', smsPrefix: 962, code: 'JO' },
	{ name: 'Kazakhstan', smsPrefix: 7, code: 'KZ' },
	{ name: 'Kenya', smsPrefix: 254, code: 'KE' },
	{ name: 'Kiribati', smsPrefix: 686, code: 'KI' },
	{ name: 'Kosovo', smsPrefix: 383, code: 'XK' },
	{ name: 'Kuwait', smsPrefix: 965, code: 'KW' },
	{ name: 'Kyrgyzstan', smsPrefix: 996, code: 'KG' },
	{ name: 'Laos', smsPrefix: 856, code: 'LA' },
	{ name: 'Latvia', smsPrefix: 371, code: 'LV' },
	{ name: 'Lebanon', smsPrefix: 961, code: 'LB' },
	{ name: 'Lesotho', smsPrefix: 266, code: 'LS' },
	{ name: 'Liberia', smsPrefix: 231, code: 'LR' },
	{ name: 'Libya', smsPrefix: 218, code: 'LY' },
	{ name: 'Liechtenstein', smsPrefix: 423, code: 'LI' },
	{ name: 'Lithuania', smsPrefix: 370, code: 'LT' },
	{ name: 'Luxembourg', smsPrefix: 352, code: 'LU' },
	{ name: 'Macao', smsPrefix: 853, code: 'MO' },
	{ name: 'Macedonia', smsPrefix: 389, code: 'MK' },
	{ name: 'Madagascar', smsPrefix: 261, code: 'MG' },
	{ name: 'Malawi', smsPrefix: 265, code: 'MW' },
	{ name: 'Malaysia', smsPrefix: 60, code: 'MY' },
	{ name: 'Maldives', smsPrefix: 960, code: 'MV' },
	{ name: 'Mali', smsPrefix: 223, code: 'ML' },
	{ name: 'Malta', smsPrefix: 356, code: 'MT' },
	{ name: 'Marshall Islands', smsPrefix: 692, code: 'MH' },
	{ name: 'Mauritania', smsPrefix: 222, code: 'MR' },
	{ name: 'Mauritius', smsPrefix: 230, code: 'MU' },
	{ name: 'Mayotte', smsPrefix: 262, code: 'YT' },
	{ name: 'Mexico', smsPrefix: 52, code: 'MX' },
	{ name: 'Micronesia', smsPrefix: 691, code: 'FM' },
	{ name: 'Moldova', smsPrefix: 373, code: 'MD' },
	{ name: 'Monaco', smsPrefix: 377, code: 'MC' },
	{ name: 'Mongolia', smsPrefix: 976, code: 'MN' },
	{ name: 'Montenegro', smsPrefix: 382, code: 'ME' },
	{ name: 'Montserrat', smsPrefix: 1664, code: 'MS' },
	{ name: 'Morocco', smsPrefix: 212, code: 'MA' },
	{ name: 'Mozambique', smsPrefix: 258, code: 'MZ' },
	{ name: 'Myanmar', smsPrefix: 95, code: 'MM' },
	{ name: 'Namibia', smsPrefix: 264, code: 'NA' },
	{ name: 'Nauru', smsPrefix: 674, code: 'NR' },
	{ name: 'Nepal', smsPrefix: 977, code: 'NP' },
	{ name: 'Netherlands', smsPrefix: 31, code: 'NL' },
	{ name: 'Netherlands Antilles', smsPrefix: 599, code: 'AN' },
	{ name: 'New Caledonia', smsPrefix: 687, code: 'NC' },
	{ name: 'New Zealand', smsPrefix: 64, code: 'NZ' },
	{ name: 'Nicaragua', smsPrefix: 505, code: 'NI' },
	{ name: 'Niger', smsPrefix: 227, code: 'NE' },
	{ name: 'Nigeria', smsPrefix: 234, code: 'NG' },
	{ name: 'Niue', smsPrefix: 683, code: 'NU' },
	{ name: 'North Korea', smsPrefix: 850, code: 'KP' },
	{ name: 'Northern Mariana Islands', smsPrefix: 1670, code: 'MP' },
	{ name: 'Norway', smsPrefix: 47, code: 'NO' },
	{ name: 'Oman', smsPrefix: 968, code: 'OM' },
	{ name: 'Pakistan', smsPrefix: 92, code: 'PK' },
	{ name: 'Palau', smsPrefix: 680, code: 'PW' },
	{ name: 'Palestine', smsPrefix: 970, code: 'PS' },
	{ name: 'Panama', smsPrefix: 507, code: 'PA' },
	{ name: 'Papua New Guinea', smsPrefix: 675, code: 'PG' },
	{ name: 'Paraguay', smsPrefix: 595, code: 'PY' },
	{ name: 'Peru', smsPrefix: 51, code: 'PE' },
	{ name: 'Philippines', smsPrefix: 63, code: 'PH' },
	{ name: 'Pitcairn', smsPrefix: 64, code: 'PN' },
	{ name: 'Poland', smsPrefix: 48, code: 'PL' },
	{ name: 'Portugal', smsPrefix: 351, code: 'PT' },
	{ name: 'Puerto Rico', smsPrefix: 1787, code: 'PR' },
	{ name: 'Qatar', smsPrefix: 974, code: 'QA' },
	{ name: 'Republic of the Congo', smsPrefix: 242, code: 'CG' },
	{ name: 'Reunion', smsPrefix: 262, code: 'RE' },
	{ name: 'Romania', smsPrefix: 40, code: 'RO' },
	{ name: 'Russia', smsPrefix: 7, code: 'RU' },
	{ name: 'Rwanda', smsPrefix: 250, code: 'RW' },
	{ name: 'Saint Barthelemy', smsPrefix: 590, code: 'BL' },
	{ name: 'Saint Helena', smsPrefix: 290, code: 'SH' },
	{ name: 'Saint Kitts and Nevis', smsPrefix: 1869, code: 'KN' },
	{ name: 'Saint Lucia', smsPrefix: 1758, code: 'LC' },
	{ name: 'Saint Martin', smsPrefix: 590, code: 'MF' },
	{ name: 'Saint Pierre and Miquelon', smsPrefix: 508, code: 'PM' },
	{ name: 'Saint Vincent and the Grenadines', smsPrefix: 1784, code: 'VC' },
	{ name: 'Samoa', smsPrefix: 685, code: 'WS' },
	{ name: 'San Marino', smsPrefix: 378, code: 'SM' },
	{ name: 'Sao Tome and Principe', smsPrefix: 239, code: 'ST' },
	{ name: 'Saudi Arabia', smsPrefix: 966, code: 'SA' },
	{ name: 'Senegal', smsPrefix: 221, code: 'SN' },
	{ name: 'Serbia', smsPrefix: 381, code: 'RS' },
	{ name: 'Seychelles', smsPrefix: 248, code: 'SC' },
	{ name: 'Sierra Leone', smsPrefix: 232, code: 'SL' },
	{ name: 'Singapore', smsPrefix: 65, code: 'SG' },
	{ name: 'Sint Maarten', smsPrefix: 1721, code: 'SX' },
	{ name: 'Slovakia', smsPrefix: 421, code: 'SK' },
	{ name: 'Slovenia', smsPrefix: 386, code: 'SI' },
	{ name: 'Solomon Islands', smsPrefix: 677, code: 'SB' },
	{ name: 'Somalia', smsPrefix: 252, code: 'SO' },
	{ name: 'South Africa', smsPrefix: 27, code: 'ZA' },
	{ name: 'South Korea', smsPrefix: 82, code: 'KR' },
	{ name: 'South Sudan', smsPrefix: 211, code: 'SS' },
	{ name: 'Spain', smsPrefix: 34, code: 'ES' },
	{ name: 'Sri Lanka', smsPrefix: 94, code: 'LK' },
	{ name: 'Sudan', smsPrefix: 249, code: 'SD' },
	{ name: 'Suriname', smsPrefix: 597, code: 'SR' },
	{ name: 'Svalbard and Jan Mayen', smsPrefix: 47, code: 'SJ' },
	{ name: 'Swaziland', smsPrefix: 268, code: 'SZ' },
	{ name: 'Sweden', smsPrefix: 46, code: 'SE' },
	{ name: 'Switzerland', smsPrefix: 41, code: 'CH' },
	{ name: 'Syria', smsPrefix: 963, code: 'SY' },
	{ name: 'Taiwan', smsPrefix: 886, code: 'TW' },
	{ name: 'Tajikistan', smsPrefix: 992, code: 'TJ' },
	{ name: 'Tanzania', smsPrefix: 255, code: 'TZ' },
	{ name: 'Thailand', smsPrefix: 66, code: 'TH' },
	{ name: 'Togo', smsPrefix: 228, code: 'TG' },
	{ name: 'Tokelau', smsPrefix: 690, code: 'TK' },
	{ name: 'Tonga', smsPrefix: 676, code: 'TO' },
	{ name: 'Trinidad and Tobago', smsPrefix: 1868, code: 'TT' },
	{ name: 'Tunisia', smsPrefix: 216, code: 'TN' },
	{ name: 'Turkey', smsPrefix: 90, code: 'TR' },
	{ name: 'Turkmenistan', smsPrefix: 993, code: 'TM' },
	{ name: 'Turks and Caicos Islands', smsPrefix: 1649, code: 'TC' },
	{ name: 'Tuvalu', smsPrefix: 688, code: 'TV' },
	{ name: 'U.S. Virgin Islands', smsPrefix: 1340, code: 'VI' },
	{ name: 'Uganda', smsPrefix: 256, code: 'UG' },
	{ name: 'Ukraine', smsPrefix: 380, code: 'UA' },
	{ name: 'United Arab Emirates', smsPrefix: 971, code: 'AE' },
	{ name: 'United Kingdom', smsPrefix: 44, code: 'GB' },
	{ name: 'United States', smsPrefix: 1, code: 'US' },
	{ name: 'Uruguay', smsPrefix: 598, code: 'UY' },
	{ name: 'Uzbekistan', smsPrefix: 998, code: 'UZ' },
	{ name: 'Vanuatu', smsPrefix: 678, code: 'VU' },
	{ name: 'Vatican', smsPrefix: 379, code: 'VA' },
	{ name: 'Venezuela', smsPrefix: 58, code: 'VE' },
	{ name: 'Vietnam', smsPrefix: 84, code: 'VN' },
	{ name: 'Wallis and Futuna', smsPrefix: 681, code: 'WF' },
	{ name: 'Western Sahara', smsPrefix: 212, code: 'EH' },
	{ name: 'Yemen', smsPrefix: 967, code: 'YE' },
	{ name: 'Zambia', smsPrefix: 260, code: 'ZM' },
	{ name: 'Zimbabwe', smsPrefix: 263, code: 'ZW' },
];
